import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsDesktop } from '@zurich/ui/hooks';
import { Card, CardContent, FormFlex, FormFlexItem, } from '@zurich/ui/legacy/components';
import { useAppLinkUi } from '@zurich/ui/legacy/hooks';
import { styled } from '@zurich/ui/legacy/utils';
export const InfoCard = ({ title, description, illustration, }) => {
    const isDesktop = useIsDesktop();
    const showIllustration = illustration && isDesktop;
    return (_jsx(Card, { children: _jsx(CardContent, { children: _jsxs(FormFlex, { rowGap: 0, columnGap: 0, flexWrap: "nowrap", justifyContent: "space-between", align: "center", children: [_jsx(FormFlexItem, { width: showIllustration ? '60%' : '100%', flexGrow: 0, children: _jsxs(TextWrapperStyled, { children: [title && _jsx(TitleStyled, { children: title }), description] }) }), showIllustration && (_jsx(FormFlexItem, { width: "40%", children: _jsx(IllustrationContainerStyled, { children: _jsx(IllustrationStyled, { children: illustration }) }) }))] }) }) }));
};
export function InfoCardLink(props) {
    const AppLinkUi = useAppLinkUi();
    return (_jsx(AppLinkUi, { ...props, href: props.href, children: props.children }));
}
const TextWrapperStyled = styled('div')({
    flexDirection: 'column',
    display: 'flex',
    height: '100%',
});
const TitleStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    height: '40%',
    [theme.breakpoints.down('xl')]: {
        paddingBottom: theme.spacing(2),
    },
}));
const IllustrationContainerStyled = styled('div')(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
}));
const IllustrationStyled = styled('div')({
    position: 'relative', // necessary for AppImages with fill property (if passed as illustration)
    minHeight: '200px',
    width: '100%',
    maxWidth: '336px',
    bottom: 0,
    display: 'table-cell',
    textAlign: 'right',
});
